import { Component, Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent  {

  @Input()
  id: any = {};
  @Input()
  isNoRecords:boolean=true;

  @Output() Click = new EventEmitter();


  Save(id: number)
  {

      this.Click.emit(id);


  }
}
